<template>

</template>

<script>
export default {
name: "mutlSelectFormCell"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/marketCenter/formCell/mutlSelectFormCell.vue